import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TiendaColegio } from "../../services/tienda-colegios/tienda-colegio.types";

export type TiendaColegioState = {
  tiendaColegios: TiendaColegio[];
  loading: boolean;
};

const initialState: TiendaColegioState = {
  tiendaColegios: [],
  loading: false,
};

const tiendaColegioSlice = createSlice({
  name: "tiendaColegio",
  initialState,
  reducers: {
    clearTiendaColegios: (state) => {
      state.tiendaColegios = [];
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTiendaColegios: (state, action: PayloadAction<TiendaColegio[]>) => {
      state.tiendaColegios = action.payload;
      state.loading = false;
    },
    addTiendaColegio: (state, action: PayloadAction<TiendaColegio>) => {
      state.tiendaColegios.unshift(action.payload);
    },
    updateTiendaColegio: (
      state,
      action: PayloadAction<{ id: number; data: TiendaColegio }>
    ) => {
      const index = state.tiendaColegios.findIndex(
        (c) => c.id === action.payload.id
      );
      if (index !== -1) {
        state.tiendaColegios[index] = action.payload.data;
      }
    },
    deleteTiendaColegio: (state, action: PayloadAction<number>) => {
      state.tiendaColegios = state.tiendaColegios.filter(
        (c) => c.id !== action.payload
      );
    },
  },
});

export default tiendaColegioSlice;
export const {
  clearTiendaColegios,
  setLoading,
  setTiendaColegios,
  addTiendaColegio,
  updateTiendaColegio,
  deleteTiendaColegio,
} = tiendaColegioSlice.actions;
